<template>
    <div class="m-search">
        <div class="m-search__bar">
            <div class="m-search__box">
                <i class="el-icon-search"></i>
                <input
                    :value="value"
                    :placeholder="placeholder"
                    @input="$emit('input', $event.target.value)"
                    @keyup.enter="$emit('search', value)"
                />
                <span class="m-search__clear" v-if="value" @click="clear">×</span>
            </div>
            <button class="m-search__go" @click="$emit('search', value)">搜索</button>
            <button class="m-search__filter" v-if="$slots.filter" @click="drawer = true">
                <i class="el-icon-s-operation"></i>
            </button>
        </div>

        <!-- 高级筛选抽屉：放置页面原有的搜索表单 -->
        <el-drawer
            title="筛选条件"
            :visible.sync="drawer"
            direction="rtl"
            size="88%"
            append-to-body
        >
            <div class="m-search__drawer">
                <slot name="filter"></slot>
            </div>
        </el-drawer>
    </div>
</template>

<script>
/* eslint-disable */
/**
 * m-search —— 手机端搜索栏 + 高级筛选抽屉
 *
 * <m-search v-model="keyword" placeholder="搜索名称" @search="onSearch">
 *   <template slot="filter"><wf-search ... /></template>
 * </m-search>
 */
export default {
    name: 'MSearch',
    props: {
        value: { type: String, default: '' },
        placeholder: { type: String, default: '搜索' },
    },
    data() {
        return { drawer: false };
    },
    methods: {
        clear() {
            this.$emit('input', '');
            this.$emit('search', '');
        },
        // 供父组件在筛选提交后关闭抽屉
        closeDrawer() {
            this.drawer = false;
        },
    },
};
</script>
